import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "cpp-modal-container" }

import { computed } from "vue";
import { useStore } from "vuex";
import CppStructureItem from "@/modules/cpp/components/CppStructureItem.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AppealModal',
  setup(__props) {

const store = useStore();

const structureItems = computed(() => store.state.appealsStore.currentAppeal);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "modal-title" }, "Заявка партнера", -1)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(structureItems.value, (item, index) => {
      return (_openBlock(), _createBlock(CppStructureItem, {
        class: "structure-item",
        "structure-index": +index,
        item: item,
        key: index,
        fields: item.fields,
        "onUpdate:textValue": _ctx.onInputHandler,
        "onUpdate:radioValue": _ctx.onRadioHandler,
        "onUpdate:datePickerValue": _ctx.onDatePickerHandler,
        "onUpdate:addFile": _ctx.onFileHandler,
        "onUpdate:dropDown": _ctx.onDropDown,
        "onUpdate:deleteFile": _ctx.onFileDelete,
        "onUpdate:multipleFiles": _ctx.onMultiplyFiles
      }, null, 8, ["structure-index", "item", "fields", "onUpdate:textValue", "onUpdate:radioValue", "onUpdate:datePickerValue", "onUpdate:addFile", "onUpdate:dropDown", "onUpdate:deleteFile", "onUpdate:multipleFiles"]))
    }), 128))
  ]))
}
}

})